import { useState } from "react";
import { createPortal } from "react-dom";
import Swal from "sweetalert2";
import "./modal.css";

function Modal({
  isOpen,
  setOpen,
  enviar,

  tipo, // post | materia | colunista | banner | video | capa
  modo = "novo",

  titulo,
  setTitulo,

  subtitulo,
  setSubtitulo,

  texto,
  setTexto,

  img,
  setImg,

  placeholderTitulo = "Digite o título",
  placeholderSubtitulo = "Digite o subtítulo",
  placeholderTexto = "Digite o texto"
}) {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  function handleFileChange(e) {
    const file = e.target.files?.[0];
    if (file) setImg(file);
  }

  const previewSrc =
    typeof img === "string"
      ? img
      : img instanceof File
      ? URL.createObjectURL(img)
      : null;

  function getTituloModal() {
    if (modo === "editar") {
      if (tipo === "banner") return "Editar Banner";
      if (tipo === "video") return "Editar Vídeo";
      if (tipo === "capa") return "Editar Capa";
      if (tipo === "materia") return "Editar Matéria";
      if (tipo === "post") return "Editar Post";
      if (tipo === "colunista") return "Editar Colunista";
    }

    if (tipo === "banner") return "Editar Banner";
    if (tipo === "video") return "Novo Vídeo";
    if (tipo === "capa") return "Nova Capa";
    if (tipo === "materia") return "Nova Matéria";
    if (tipo === "post") return "Novo Post";
    if (tipo === "colunista") return "Novo Colunista";

    return "Novo";
  }

  async function handleSubmit() {
    try {
      setLoading(true);
      await enviar();

      Swal.fire({
        icon: "success",
        title: "Salvo com sucesso!",
        timer: 1200,
        showConfirmButton: false
      });

      setOpen(false);
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: err.message || "Erro ao salvar"
      });
    } finally {
      setLoading(false);
    }
  }

  return createPortal(
    <div className="container-modal" onClick={() => setOpen(false)}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title">{getTituloModal()}</h2>

        {/* ================= POST ================= */}
        {tipo === "post" && (
          <>
            <input
              className="modal-input"
              placeholder={placeholderTitulo}
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              disabled={loading}
            />

            <textarea
              className="modal-textarea"
              placeholder={placeholderTexto}
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              disabled={loading}
            />

            <label className="file-label">
              Selecionar imagem
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleFileChange}
                disabled={loading}
              />
            </label>
          </>
        )}

        {/* ================= MATÉRIA ================= */}
        {tipo === "materia" && (
          <>
            <input
              className="modal-input"
              placeholder={placeholderTitulo}
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              disabled={loading}
            />

            <input
              className="modal-input"
              placeholder={placeholderSubtitulo}
              value={subtitulo}
              onChange={(e) => setSubtitulo(e.target.value)}
              disabled={loading}
            />

            <textarea
              className="modal-textarea"
              placeholder={placeholderTexto}
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              disabled={loading}
            />

            <label className="file-label">
              Selecionar imagem
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleFileChange}
                disabled={loading}
              />
            </label>
          </>
        )}

        {/* ================= COLUNISTA ================= */}
        {tipo === "colunista" && (
          <>
            <input
              className="modal-input"
              placeholder="Nome do colunista"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              disabled={loading}
            />

            <label className="file-label">
              Selecionar foto
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleFileChange}
                disabled={loading}
              />
            </label>
          </>
        )}

        {/* ================= BANNER / CAPA ================= */}
        {(tipo === "banner" || tipo === "capa") && (
          <label className="file-label">
            Selecionar imagem
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleFileChange}
              disabled={loading}
            />
          </label>
        )}

        {/* ================= VÍDEO ================= */}
        {tipo === "video" && (
          <label className="file-label">
            Selecionar vídeo
            <input
              type="file"
              hidden
              accept="video/*"
              onChange={handleFileChange}
              disabled={loading}
            />
          </label>
        )}

        {/* ================= PREVIEW ================= */}
        {previewSrc && tipo !== "video" && (
          <img className="preview-media" src={previewSrc} alt="preview" />
        )}

        {previewSrc && tipo === "video" && (
          <video className="preview-media" src={previewSrc} controls />
        )}

        {/* ================= AÇÕES ================= */}
        <div className="modal-actions">
          <button
            className="btn-cancel"
            onClick={() => setOpen(false)}
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            className="btn-submit"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default Modal;
